const strateMaillageBlogGuide = {
    init() {
        const breakpointResponsive = 1140;
        const sectionMaillage = document.getElementsByClassName('strate-maillage-blog-guide');
        // console.log(sectionMaillage);
        if (sectionMaillage.length > 0) {
            if ($(window).width() < breakpointResponsive) {
                strateMaillageBlogGuide.responsive('none');
            }

            $(window).resize(
                function () {
                    if ($(window).width() < breakpointResponsive) {
                        strateMaillageBlogGuide.responsive('none');
                    } else {
                        strateMaillageBlogGuide.responsive('inline-flex');
                    }
                }
            );
        }
    },

    responsive(action) {
        const posts = document.querySelectorAll('.wrapper_post .post');
        // console.log('posts', posts);
        const guides = document.querySelectorAll('.wrapper_guide .post');
        // console.log('guides', guides);
        if (posts.length > 1) {
            const lastChildInd = posts.length - 1;
            // console.log(posts[lastChildInd]);
            const lastChild = posts[lastChildInd];
            lastChild.style.display = action;
        }
        if (guides.length > 1) {
            const lastChildInd = posts.length - 1;
            // console.log(posts[lastChildInd]);
            const lastChild = guides[lastChildInd];
            lastChild.style.display = action;
        }
    },

};
export default strateMaillageBlogGuide;

